import { Typography, Box } from "@mui/material";
import { MapsService } from "../services/functions/mapsService";
import { LocationOn } from "@mui/icons-material";

interface DistancePillProps {
    itemLat: number;
    itemLon: number;
    userLat: number;
    userLon: number;
}

export const DistancePill = ({ itemLat, itemLon, userLat, userLon }: DistancePillProps) => {
    const dist = MapsService.distance(userLat, userLon, itemLat, itemLon);

    return (
        <Box display="flex" alignItems="center" gap={0.5}>
            <LocationOn sx={{ fontSize: 18, color: "#162C1F" }} />
            <Typography variant="body2" color="text.secondary" fontWeight={500}>
                {dist} km
            </Typography>
        </Box>
    );
};
